import { useQuery } from "react-query";
import { supportWidgetApi } from "@circle-react/api/supportWidgetApi";
import { ONE_HOUR } from "../constants";

const useListSpaceGroups = () =>
  useQuery("space-groups", () => supportWidgetApi.spaceGroups(), {
    staleTime: ONE_HOUR,
    retry: false,
  });

export default useListSpaceGroups;
